// Development environment configuration
export const environment = {
    production: false,
    environmentName: 'development',
    firebaseConfig: {
        apiKey: "AIzaSyDCavt1GV-EDXE9Mf_mQXKq7CrKNPa5z9g",
        authDomain: "arrisfinance.firebaseapp.com",
        projectId: "arrisfinance",
        storageBucket: "arrisfinance.firebasestorage.app",
        messagingSenderId: "186744483207",
        appId: "1:186744483207:web:93355004775ce97e7eb722",
        measurementId: "G-2GEZXE4EFD",
        // Development uses the default database
        databaseId: "(default)"
    },
    geminiApiKey: "AIzaSyDCavt1GV-EDXE9Mf_mQXKq7CrKNPa5z9g"
};
